import * as React from 'react';
import { FormControl, FormGroup } from 'react-bootstrap';

import './NotesSection.css';
import { Section } from './Section';

interface NotesProps {
  notes?: string;
  editing: boolean;
  onChange: (notes: string) => void;
}

export const NotesSection = ({ notes = '', editing, onChange }: NotesProps) => {
  const change = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    if (event.target.value.length <= 300 ) {
      onChange(event.currentTarget.value);
    }
  };
  const count = 300 - notes.length;

  return (
    <Section title="Notes" className="NotesSection">
      {editing ? (
        <FormGroup controlId="notes">
           <textarea
            value={notes}
            placeholder="Notes"
            rows={5}
            onChange={change}
           />
          <span className="Notes__char-count text-muted">{count} char left</span>
        </FormGroup>
      ) : (
        <FormControl.Static style={{ minHeight: 94 }}>
          {notes.split('\n').map((paragraph, i) => (
            <span key={`details-line-${i}`}>
              {paragraph}
              <br />
            </span>
          ))}
        </FormControl.Static>
      )}
    </Section>
  );
};



// WEBPACK FOOTER //
// ./src/DocView/Section/NotesSection.tsx